import React, { useState } from 'react';
import './BoardCodeForm.css'; // ✅ CSS 추가

function BoardCodeForm({ initialData = {}, onSubmit, formId = "board-code-form", editableCode = false }) {
  const [formData, setFormData] = useState({
    code: initialData.code || '',
    name: initialData.name || '',
    description: initialData.description || '',
    is_active: initialData.is_active ?? true,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form id={formId} className="board-code-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>코드</label>
        <input
          name="code"
          value={formData.code}
          onChange={handleChange}
          className="form-input"
          placeholder="게시판 코드"
          readOnly={!editableCode}
        />
      </div>

      <div className="form-group">
        <label>이름</label>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="form-input"
          placeholder="게시판 이름"
        />
      </div>

      <div className="form-group">
        <label>설명</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="form-textarea"
          placeholder="게시판 설명"
        />
      </div>

      <div className="form-group">
        <label>상태</label>
        <select
          name="is_active"
          value={formData.is_active ? 'true' : 'false'}
          onChange={(e) => setFormData({ ...formData, is_active: e.target.value === 'true' })}
          className="form-select"
        >
          <option value="true">활성</option>
          <option value="false">비활성</option>
        </select>
      </div>
    </form>
  );
}

export default BoardCodeForm;